/**
 * 虚拟电厂相关接口
 */

import Axios from '@/components/api/axios.js'

export default  {
    get3dDevicesInfo:(akrCdz,xxCdz,success,failure) => {
        Axios.post('/virtualPowerPlant/get3dDevicesInfo.do', {
            akrCdz,
            xxCdz
        },success,failure)
    },
    getInverterInfo:(gfVariableNames,success,failure) => {
        Axios.post('/virtualPowerPlant/getInverterInfo.do',{
            gfVariableNames
        },success,failure)
    },
    searchCnHistory: (cnVariableName,dateType,startTime,endTime,type,success,failure) => {
        Axios.post('/virtualPowerPlant/searchCnHistory.do',{
            cnVariableName,
            dateType,
            startTime,
            endTime,
            type
        },success,failure)
    },
    getCnInfo: (cnVariableName,startTime,endTime,success,failure) => {
        Axios.post('/virtualPowerPlant/getCnInfo.do',{
            cnVariableName,
            startTime,
            endTime
        },success,failure)
    },
    getPlantParams: (unitId,success,failure) => {
        Axios.post('/virtualPowerPlant/getPlantParams.do', {
            unitId
        },success,failure)
    },
    savePlantParams: (unitId,carbon,sulfur,gfMianji,gfZhujian,fuzhao,qingxiejiao,success,failure) => {
        Axios.post('/virtualPowerPlant/savePlantParams.do', {
            unitId,
            carbon,
            sulfur,
            gfMianji,
            gfZhujian,
            fuzhao,
            qingxiejiao
        },success,failure)
    },
    getCdzDayMaxLoad: (variableNames,time,success,failure) => {
        Axios.post('/virtualPowerPlant/getCdzDayMaxLoad.do', {
            variableNames,
            time
        },success,failure)
    },
    getCdzMonthMaxLoad:(variableNames,time,success,failure) => {
        Axios.post('/virtualPowerPlant/getCdzMonthMaxLoad.do', {
            variableNames,
            time
        },success,failure)
    },
    getAllTypeVariableName:(unitId,success,failure) => {
            Axios.post('/virtualPowerPlant/getAllTypeVariableName.do', {
                unitId
            },success,failure)
        },
    getCdzInfo:(variableNames,cnVariableName,gfVariableNames,xxCdz,success,failure) => {
        Axios.post('/virtualPowerPlant/getCdzInfo.do', {
            variableNames,
            cnVariableName,
            gfVariableNames,
            xxCdz
        },success,failure)
    },
    getDeviceRunInfo:(cdzVariableNames,gfVariableNames,cnVariableNames,time,success,failure) => {
        Axios.post('/virtualPowerPlant/getDeviceRunInfo.do', {
            cdzVariableNames,
            gfVariableNames,
            cnVariableNames,
            time
        },success,failure)
    }
}
